import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { nl } from "./locales/nl";
import { en } from "./locales/en";
// Side-effect import: augments i18next with typed translation keys.
import "./locales/types";

export type Locale = "nl" | "en";
export const LOCALE_STORAGE_KEY = "wlx:locale";

// Keep in sync with the pre-paint script in index.html, which reads the same
// key to set <html lang> before this module has even loaded.
function getInitialLocale(): Locale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    return stored === "en" ? "en" : "nl";
  } catch {
    return "nl";
  }
}

// The page says which language it is in: screen readers pick their
// pronunciation from <html lang>, and the browser its hyphenation and spellcheck
// defaults. index.html sets it before first paint; this keeps it right after
// every switch in the user menu.
function setDocumentLanguage(lng: string): void {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng === "en" ? "en" : "nl";
}

const initialLocale = getInitialLocale();
i18n.on("languageChanged", setDocumentLanguage);

i18n.use(initReactI18next).init({
  resources: {
    nl: { translation: nl },
    en: { translation: en },
  },
  lng: initialLocale,
  fallbackLng: "nl",
  interpolation: { escapeValue: false },
});
// Not left to the init event alone: whether init emits it synchronously is an
// i18next detail, and the page language must not depend on one.
setDocumentLanguage(initialLocale);

export default i18n;
